import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MongoExplorer = lazy(() =>
  import("@scenes/MongoExplorer/MongoExplorer").then((module) => ({
    default: module.MongoExplorer,
  }))
);

export const mongoExplorerNRO: NavigationRoutingObject = {
  Component: MongoExplorer,
  componentFeatureFlippers: [],
  section: "braze-tools",
  icon: "nav-system-analytics-dashboard",
  heading: (t: I18nT<"dashboard-navigation">) => t("mongo-explorer-nro-heading", "Mongo Explorer"),
  pageNameForTracking: () => "Mongo Explorer",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("mongo-explorer-nro-description", "Internal tool for Braze employees to explore MongoDB data"),
  tag: "beta",
  getDeveloperNavigationAllowed: ({ isInternalDeveloper, featureOn }) => {
    return isInternalDeveloper && featureOn("mongo_explorer");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  noKnockoutFallback: true,
};
